import { TFunction } from "i18next";

import { formatHelpTopicLabel } from "@ryde/shared";

export const buildHelpTopicSearchHaystack = (
  topicId: string,
  manifestLabel: string | undefined,
  t: TFunction,
): string => {
  const translatedLabel = t(`systemParam.formLabel.${topicId}`, {
    defaultValue: "",
  });

  return [
    topicId,
    manifestLabel,
    formatHelpTopicLabel(topicId),
    translatedLabel,
  ]
    .filter((value): value is string => Boolean(value))
    .join(" ")
    .toLowerCase();
};

export const matchesHelpTopicSearch = (
  haystack: string,
  query: string,
): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return true;
  }

  return normalizedQuery.split(/\s+/).every(token => haystack.includes(token));
};
